<template>
    <div>
        <gofix-card title="Requestor Info">
            <template v-if="!IsReadOnly && $checkRole(this.$accessModule.order_tabs.main_info, 'update') && ( Item.order_status === 'Issued' || Item.order_status === 'Under Approval' )" slot="gofixCard:right_header">
                <button class="icon-button" @click="open = true"><img width="20" src="img/iconPencil.png" alt="" /></button>
            </template>
            <b-row>
                <b-col md="5" class="requestor-info-column-1">
                    <gofix-text-field class="mb-3" label="Client Contract" oneline>{{Item.client_contract ? Item.client_contract.contract_name : null}}</gofix-text-field>
                </b-col>
                <b-col md="4" class="requestor-info-column-2">
                    <gofix-text-field class="mb-3" label="Client" oneline>{{Item.get_client ? Item.get_client.name : null}}</gofix-text-field>
                </b-col>
                <b-col md="3">
                    <gofix-text-field label="Client WO Number" oneline>{{Item.client_wo_number || "-"}}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                 <b-col md="5" class="requestor-info-column-1">
                    <gofix-text-field label="Service Location" oneline>{{Item.property ? Item.property.root_path : null}}</gofix-text-field>
                </b-col>
                <b-col md="4" class="requestor-info-column-2">
                    <gofix-text-field label="Caller Detail" oneline>
                        <div v-if="Item.service_address">
                            <p class="pr-3">{{Item.service_address.display_name}}</p>
                            <span :class="{'pr-3': Item.service_address.primary_phone || Item.service_address.secondary_phone}">{{Item.service_address.primary_phone ? Item.service_address.primary_phone : Item.service_address.secondary_phone }}</span>
                            <span>{{Item.service_address.email}}</span>
                        </div>
                    </gofix-text-field>
                </b-col>
                <b-col md="3">
                    <gofix-text-field label="WO Date Created" oneline>{{Item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}</gofix-text-field>
                </b-col>
            </b-row>
        </gofix-card>
         <b-modal
            :no-close-on-backdrop="true"
            title="Requestor Info "
            hide-footer
            :centered="true"
            modal-class="modal-create"
            @shown="shownModal"
            v-model="open">
            <b-form class="formV2" v-bind:class="{'run-loading':loading}">
                <gofix-form-input label="Client Contract" disabled v-model="Item.client_contract.contract_name"></gofix-form-input>

                <gofix-form-properties
                    label="Select Location"
                    :contract-id="Item ? Item.contract_id : null"
                    valueFormat="object"
                    v-model="data.property">
                </gofix-form-properties>

                <gofix-form-input label="Client WO number" v-model="data.client_wo_number"></gofix-form-input>

                <gofix-form-dropdown
                    v-if="!address.new"
                    label="Caller Name"
                    vLabel="name"
                    :filterable="false"
                    @search="searchAddress"
                    :getOptionLabel="getOptionLabel"
                    v-model="data.service_address"
                    :options="address.data">
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <span class="color-000">{{ option.display_name }} - {{option.email}}</span>
                    </template>
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="color-000">{{ option.display_name }} - {{option.email}}</span>
                    </template>
                </gofix-form-dropdown>
                <b-row class="mb-10" v-if="!address.new && data.service_address">
                    <b-col md="7">
                        <div class="content overflow-hidden">
                            <label>Email</label> <div class="info-right">{{data.service_address ? data.service_address.email : '-'}}</div>
                        </div>
                    </b-col>
                    <b-col md="5" class="pl-0">
                        <div class="content overflow-hidden">
                            <label>Phone Number</label> <div class="info-right">{{data.service_address.primary_phone}}</div>
                        </div>
                    </b-col>
                </b-row>
                <gofix-form-input label="Caller Name" v-if="address.new" v-model="address.newData.display_name"></gofix-form-input>
                <gofix-form-input label="Email" v-if="address.new" v-model="address.newData.email"></gofix-form-input>
                <gofix-form-input-number label="Phone Number" v-if="address.new" v-model="address.newData.primary_phone" :integer-limit="15" :include-thousands-separator="false" :allowDecimal="false"></gofix-form-input-number>
                <gofix-button v-if="!address.new" label="new caller" @click="address.new = true" outline></gofix-button>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveData" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'requestor-info',
        components: {},
        data () {
            return {
                open: false,
                loading: false,
                data: {
                    property : null,
                    client_wo_number : null,
                    service_address : null,
                },
                treeProperty: [],
                address:{
                    data: [],
                    new: false,
                    timer: null,
                    newData:{
                        display_name : null,
                        email : null,
                        primary_phone : null,
                    }
                }
            }
        },
        watch: {
            "Item.contract_id" : function (val) {
                this.getProperty(0,true);
            },
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
        },
        created() {
            if(this.Item) {
                this.getProperty(0,true);
            }
            this.getAddressList();
        },
        methods: {
            getOptionLabel(option){
              let label = option.display_name;
              return label;
            },
            /*- Save data ---------*/
            async saveData(){
                let data = {};
                if(this.address.new){
                    let bug = false;
                    if(!this.address.newData.display_name){
                        bug = true;
                        this.$alertNotification("Please enter the contact name field", "warning");
                    }
                    if(!this.address.newData.email){
                        bug = true;
                        this.$alertNotification("Please enter the email field", "warning");
                    }
                    if(!this.address.newData.primary_phone){
                        bug = true;
                        this.$alertNotification("Please enter the phone field", "warning");
                    }
                    if(bug) return ;
                    data = {
                        new_service_address : this.address.newData,
                        service_location:this.data.property.id,
                        client_wo_number:this.data.client_wo_number,
                    };
                }else{
                    data = {
                        service_contact_id : this.data.service_address ? this.data.service_address.id : null,
                        service_location:this.data.property.id,
                        client_wo_number:this.data.client_wo_number,
                    }
                }

                if(data.service_location !== this.Item.service_location){
                    data.equipment_ids = [];
                }

                this.loading = true;
                this.$store.dispatch("OrderController/updateItem",{ id:this.Item.id, data: data })
                    .then(response => {
                        this.open = false;
                        this.loading = false;
                        this.$alertNotification(this.$notificationV2('editing', 'requestor')); 
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    })

            },

            /*- Load data ---------*/
            async getProperty(property_root_id = 0, setRoot = false) {
                let data = null;
                await global.axios(`api/contracts/${this.Item.contract_id}/tree-properties/${property_root_id}`, { method: "GET", headers: { Accept: "application/json", } })
                        .then(response => {
                            data = response.data.data;
                        }).catch(
                            error => {}
                        );
                if(setRoot){
                    this.treeProperty = data;
                }else{
                    return data;
                }
            },
            getAddressList(){
                this.$store.dispatch("AddressController/getItems",{
                    page:1,
                    limit: 100,
                }).then(response => {
                    this.address.data = response.items;
                })
                .catch(err => {
                    console.log(err);
                })
            },

            /*- attribute method ----*/
            searchAddress(search, loading) {
                this.address.data = [];
                loading(true);
                if(this.address.timer) {
                    clearTimeout(this.address.timer);
                    this.address.timer = null;
                }
                this.address.timer = setTimeout(() => {
                    this.$store.dispatch("AddressController/getItems",{
                        page:1,
                        limit: 100,
                        filter: {
                            search: search
                        }
                    }).then(response => {
                        this.address.data = response.items;
                        loading(false);
                    })
                    .catch(err => {
                        console.log(err);
                        loading(false);
                    });
                }, 500);
            },
            shownModal(){
                this.data = {
                    property: this.Item.property,
                    client_wo_number: this.Item.client_wo_number,
                    service_address: this.Item.service_address,
                };
                this.address.new = false;
            }
        },
    }
</script>
